import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { UserConfigsUtils } from "../utils/UserConfigsUtils";

@Injectable()
export class LoginService {
  private log;
  private user: any = null;
  private loginTokenName = "tokenUnionSolutions";

  constructor() {
    this.log = new BehaviorSubject(this.user);
    this.logIn(this.getTokenLogin());
  }

  isEmpty(token) {
    if (token === null) {
      return true;
    }

    const tokenFormat = token
      .toString()
      .toLowerCase()
      .trim()
      .replace("null", "");
    return tokenFormat === "";
  }

  decodeToken(token) {
    token = token || this.getTokenLogin();

    if (this.isEmpty(token)) {
      return false;
    }

    token = token.substring(0, token.indexOf("."));

    const decode = decodeURIComponent(
      Array.prototype.map
        .call(atob(token), (c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(decode);
  }

  getTokenLogin() {
    const token = localStorage.getItem(this.loginTokenName);
    return this.isEmpty(token) ? "" : token;
  }

  private setTokenLogin(value) {
    localStorage.setItem(this.loginTokenName, value);
  }

  private removeTokenLogin() {
    localStorage.removeItem(this.loginTokenName);
  }

  private removeIpClient() {
    UserConfigsUtils.removeUserConfigsStorage();
  }

  getLogIn(): Observable<any> {
    return this.log.asObservable();
  }

  logIn(token) {
    if (this.isEmpty(token)) {
      return;
    }

    this.setTokenLogin(token);
    let user = this.decodeToken(token);
    if (user && user != "null") {
      user.status = true;
    } else {
      user = null;
    }

    this.user = user;
    //this.setValidacaoRotas();
    this.log.next(this.user);
  }

  logOut() {
    this.removeTokenLogin();
    this.removeIpClient();
    this.user = null;
    this.log.next(this.user);
  }

  /*
  setValidacaoRotas() {
    let permissoes = [];
    if (this.user) {
      if (!this.user.somenteVisualizacao) {
        permissoes = [...this.user.unidade.permissoes, 'consulta_alterar'];
      } else {
        permissoes = [...this.user.unidade.permissoes, 'consulta_visualizar'];
      }

      if(this.user.visualizarAuditoria) {
        permissoes = [...permissoes, 'auditoria_visualizar'];
      }

      if(this.user.administrador) {
        permissoes.push('administrador');
      }

      this.user.permissoes = permissoes;
      
    }
  }*/
}
